import { HelperCore } from '@/common/dependencies';
import { Tooltip as AntdTooltip } from 'antd';

const Tooltip = props => {
  if (HelperCore.isPhone()) {
    return <>{props.children}</>;
  } else {
    return <AntdTooltip {...props}>{props.children}</AntdTooltip>;
  }
};
export default Tooltip;
